'use client';
import { useState, useEffect } from 'react';
import Image from 'next/image';
import { useIsDesktop } from '@/hooks/useIsDesktop';

export const ColorfulBorder = () => {
  const isDesktop = useIsDesktop();
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) {
    return <div className="relative w-full h-3 lg:h-6" />;
  }

  return (
    <div className="relative w-full h-3 lg:h-6 inset-0">
      {isDesktop ? (
        <Image
          src="https://images.ctfassets.net/0sea1vycfyqy/4RvkJdOREUJIafOgamNMFi/7a2e197ce1040484fac23e3fbbd1b003/New_Border.png"
          alt="Colorful Border (Large)"
          fill
        />
      ) : (
        <Image
          src="https://images.ctfassets.net/0sea1vycfyqy/7vcAmWLK2EbtrwRT3rUVzT/4a14d7ca471f89474a14f4f010a5995d/Group_1030.png"
          alt="Colorful Border"
          fill
        />
      )}
    </div>
  );
};

export const ColorfulBorderAlt = () => {
  const isDesktop = useIsDesktop();
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) {
    return <div className="relative w-full h-3 lg:h-6 inset-0" />;
  }

  return (
    <div className="relative w-full h-3 lg:h-6 inset-0">
      {isDesktop ? (
        <Image
          src="https://images.ctfassets.net/0sea1vycfyqy/6FDo1Bwrg52YoTU0lkXQiq/c60d2cc4196f23513704cdf929d289e3/Group_1476.png"
          alt="Colorful Border Alt (Large)"
          fill
        />
      ) : (
        <Image
          src="https://images.ctfassets.net/0sea1vycfyqy/3io9g1UNvRIsSX0gn953zk/0b89369d7db03dae0464d92b98487840/Screenshot_2024-03-08_at_12.01_1.png"
          alt="Colorful Border Alt"
          fill
        />
      )}
    </div>
  );
};
